import React, { Component } from 'react';
import {connect} from 'react-redux';

import { Button, Grid, IconButton, Modal } from '@material-ui/core';
import { delRoomByCommunity, getRoomsByCommunityId } from '../../actions/roomAction';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortAlphaDown, faSortAlphaUpAlt, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import AddEditRoom from './AddEditRoom';




class RoomsList extends Component {
    constructor(props){
        super(props);

        this.state = {
           sortDesc: true,
           characterLimit:30,
           openRooms:false,
           selectedRoom:undefined,
           SweetAlertStyles: {modalStyles:{backgroundColor: '#ffffff'}, messageClass:'LAlertMessageStyles'},

        }

    }

    componentDidMount(){
        this.getRooms();
    }

    componentDidUpdate(prevProps){
        if(prevProps.communityId!==this.props.communityId){
            this.setState({
                sortDesc:true
            })
        }
    }

    getRooms =()=>{
        this.props.getRoomsByCommunityId(localStorage.getItem('communityId'), true, this.state.sortDesc);

    }

    handleSort =()=>{
        this.setState((prevState)=>({sortDesc:!prevState.sortDesc}), ()=>this.getRooms())
    }

    handleUpdate=(e, room)=>{
        this.setState({selectedRoom:room, openRooms:true})
    }

    handleDelete=(e, id)=>{
        this.props.delRoomByCommunity(id, this.state.SweetAlertStyles? this.state.SweetAlertStyles : {});
    }

    handleCloseAddRoom=()=>{
        this.setState({openRooms:false, selectedRoom:undefined}, ()=>this.getRooms());
        
    }



    render() {
        return (
            <>
                <Grid item container xs={12} justifyContent='center' alignContent='flex-start' className='setUpsectionContainer'>
                    {/* Title and button */}
                    <Grid item container xs={12} justifyContent='space-between'  alignItems='flex-start'>
                        <Grid item className='LsetUpTitle'>{`Rooms (${this.props.rooms?this.props.rooms.length:0})`}</Grid>

                        <Button className='Lsetup_btn' onClick={()=>this.setState({openRooms:true})}>
                            Add Room
                        </Button>
                    </Grid>


                    <Grid item xs={12} className='LRepairsOpenedHeaders' style={{paddingLeft:'20px', paddingTop:'20px'}}>
                        Room Name
                        <IconButton onClick={this.handleSort}>
                            <FontAwesomeIcon icon={this.state.sortDesc? faSortAlphaDown: faSortAlphaUpAlt} color='#a2a1a2' />
                        </IconButton>
                    </Grid>

                    <Grid item container xs={12}  className="roomsContainer">
                        {
                            this.props.rooms && this.props.rooms.map((r, index)=>{
                                return(
                                    <Grid item container xs={12} key={r._id} className='roomRow'
                                        style={{backgroundColor:(index%2!==0)?'#fafafa':'transparent'}}
                                        justifyContent='space-between' alignItems='center'
                                    >
                                        <Grid item xs={9} lg={10} style={{paddingLeft:'10px', cursor:'pointer'}}
                                            onClick={(e)=>this.handleUpdate(e, r)}
                                        >
                                            {r.name}
                                        </Grid>

                                        <IconButton onClick={(e)=>this.handleDelete(e, r._id)}>
                                            <FontAwesomeIcon icon={faTrashAlt} color='#c55e42' size='sm'/>
                                        </IconButton>
                                    </Grid>
                                )
                            })
                        }
                    </Grid>

                   


                </Grid>

                <Modal
                    open={this.state.openRooms}
                    style={{ borderRadius: '16px' }}
                    onClose={this.handleCloseAddRoom}
                >
                    <AddEditRoom
                        close={this.handleCloseAddRoom}
                        characterLimit={this.state.characterLimit}
                        data={this.state.selectedRoom}
                    />
                </Modal>
            </>
        )
    }
}

function mapStateToProps(state,dispatch) {
    let rooms = (state.roomReducer && state.roomReducer.roomData) ? state.roomReducer.roomData : [];

    return{
        rooms
    }
};

export default connect(mapStateToProps,{getRoomsByCommunityId, delRoomByCommunity})(RoomsList)

